module.exports = {"buttonSendText":{"en":"Go Back To App","de":"Verifikation Beenden","ro":"Către Kaufland App\u0000"}}


//////////////////
// WEBPACK FOOTER
// ./src/localization/localization-goBackButton.json
// module id = 106
// module chunks = 0